var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4996 2.075V13.925C19.4996 14.3582 19.3454 14.729 19.037 15.0374C18.729 15.3458 18.3582 15.5 17.9246 15.5H2.075C1.6414 15.5 1.2706 15.3458 0.9626 15.0374C0.6542 14.729 0.5 14.3582 0.5 13.925V2.075C0.5 1.6418 0.6542 1.271 0.9626 0.9626C1.2706 0.6542 1.6414 0.5 2.075 0.5H17.9246C18.3582 0.5 18.729 0.6542 19.037 0.9626C19.3454 1.271 19.4996 1.6418 19.4996 2.075ZM1.7498 4.5248H18.2498V2.075C18.2498 1.9918 18.2164 1.9168 18.1496 1.85C18.0832 1.7832 18.0082 1.7498 17.9246 1.7498H2.075C1.9914 1.7498 1.9164 1.7832 1.85 1.85C1.7832 1.9168 1.7498 1.9918 1.7498 2.075V4.5248ZM1.7498 7.325V13.925C1.7498 14.0082 1.7832 14.0832 1.85 14.15C1.9164 14.2168 1.9914 14.2502 2.075 14.2502H17.9246C18.0082 14.2502 18.0832 14.2168 18.1496 14.15C18.2164 14.0832 18.2498 14.0082 18.2498 13.925V7.325H1.7498Z",
    fill: "#617380"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/CardIcon.49415786.svg";
export { ForwardRef as ReactComponent };